/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Form, Formik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';

import Icon from 'components/Icon';
import { ROUTES_FEEKAPP } from 'constants/routes';
import { PURPLE_FEEK, PURPLE_LIGHT } from 'styles/colors';
import { FormInputText } from 'components/inputs/InputText';
import { ReactComponent as MagnifyingGlass } from 'assets/icons/MagnifyingGlass.svg';

const styles = css`
  .search-input {
    background-color: red;
  }
`;

export default function CampaignsSearchInput({
  className,
  placeholder,
  ...restProps
}) {
  const navigate = useNavigate();
  const { search } = useParams();

  const submitSearch = (values) => {
    navigate(
      ROUTES_FEEKAPP.SEARCH.replace(':search', values.searchValue),
    );
  };

  return (
    <Formik
      onSubmit={submitSearch}
      initialValues={{ searchValue: search || '' }}
      validateOnMount
    >
      {() => (
        <Form className={className} css={styles}>
          <FormInputText
            className="search-input"
            name="searchValue"
            backgroundColor={PURPLE_LIGHT}
            placeholder={placeholder || 'Buscar'}
            icon={
              <Icon
                height={22}
                heightMobile={14}
                color={PURPLE_FEEK}
                icon={MagnifyingGlass}
              />
            }
            {...restProps}
          />
        </Form>
      )}
    </Formik>
  );
}

CampaignsSearchInput.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
};
